<select
  soho-dropdown
  name="lm-list-dropdown"
  attr.name="lm-list-dropdown"
  data-automation-id="lm-list-dropdown"
  multiple
  soho-alert
  soho-trackdirty
  soho-input-validate
  showSearchUnderSelected="true"
  reload="{{sohoReloadStyle}}"
  moveSelected="all"
  soho-busyindicator
  blockUI="true"
  displayDelay="0"
  [readonly]="readonly ? true : null"
  [attr.tabindex]="!isInAccessibilityMode && readonly ? -1 : null"
  [(ngModel)]="values"
  [maxSelected]="options.maxValues"
  [source]="source"
  [closeOnSelect]="false"
  (change)="onChanged($event)"
  (dirty)="onDirty($event)"
  (pristine)="onPristine($event)"
  (afterResetDirty)="onAfterResetDirty($event)"
  >
  @for (item of states; track trackByValue(i, item); let i = $index) {
    <option id="i"  [selected]="item.selected" [value]="item.value" disabled="{{item.disabled}}" title={{item.tooltip}}>{{item.label}}</option>
  }
</select>